<refactor-card-header>
  <div class="code-container">      
    <!-- show docs -->
          
       <div *ngIf="documentList.length > 0">
        <div *ngFor="let document of documentList" class="card-code">
         
          <div class="card-header">
            <h4>{{ document.fileName }}.{{ document.fileExtension }}</h4>
          </div>
          <div class="card-body">
            <!-- show content docs in Monaco Editor -->
            <!-- <pre class="code-content">{{ document.fileContent }}</pre> -->
            <ngx-monaco-editor [options]="codeEditorOptions" [(ngModel)]="document.fileContent">{{ document.fileContent }}</ngx-monaco-editor> 
          </div>
        </div>
      </div>
      <!-- if there are error, shoe the error -->
      <div *ngIf="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
      </div>
    </div>
    
  <button class="download-button" (click)="onDownload()">Descargar</button>
  <a (click)="returnfileUpload()" class="return-update-file">
    Comenzar de nuevo
  </a>
</refactor-card-header>
